import React, { useState, useRef } from 'react';
import { ChevronDown } from 'lucide-react';
import { useClickOutside } from './useClickOutside';
import { servicePages, knowledgePages, serviceItems, knowledgeItems } from './headerData';
interface DesktopNavProps {
  currentPage: string;
  handleNavClick: (page: string) => void;
  t: (key: string) => string;
}
export function DesktopNav({
  currentPage,
  handleNavClick,
  t
}: DesktopNavProps) {
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isKnowledgeOpen, setIsKnowledgeOpen] = useState(false);
  const servicesRef = useRef<HTMLDivElement>(null);
  const knowledgeRef = useRef<HTMLDivElement>(null);
  useClickOutside(servicesRef, () => setIsServicesOpen(false));
  useClickOutside(knowledgeRef, () => setIsKnowledgeOpen(false));
  const isServicesActive = servicePages.includes(currentPage);
  const isKnowledgeActive = knowledgePages.includes(currentPage);
  return <nav className="hidden lg:flex items-center gap-1" data-id="element-16331">
      {/* 1. Услуги Dropdown */}
      <div className="relative" ref={servicesRef} data-id="element-16332">
        <button onClick={() => {
        setIsServicesOpen(!isServicesOpen);
        setIsKnowledgeOpen(false);
      }} className={`flex items-center gap-1 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${isServicesActive ? 'text-indigo-600 bg-indigo-50' : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'}`} data-id="element-16333">
          {t('nav.services')}
          <ChevronDown className={`w-3.5 h-3.5 transition-transform duration-200 ${isServicesOpen ? 'rotate-180' : ''}`} data-id="element-16334" />
        </button>
        {isServicesOpen && <div className="absolute top-full left-0 mt-1.5 w-72 rounded-xl shadow-xl bg-white ring-1 ring-slate-900/5 z-50 overflow-hidden" data-id="element-16335">
            <div className="p-1.5" data-id="element-16336">
              {serviceItems.map(item => <button key={item.page} onClick={() => {
            handleNavClick(item.page);
            setIsServicesOpen(false);
          }} className="flex items-start gap-3 w-full text-left px-3 py-2.5 rounded-lg hover:bg-slate-50 transition-colors group" data-id="element-16337">
                  <div className="mt-0.5 p-1.5 rounded-md bg-slate-50 group-hover:bg-white transition-colors" data-id="element-16338">
                    {item.icon}
                  </div>
                  <div data-id="element-16339">
                    <div className="text-sm font-semibold text-slate-900 group-hover:text-indigo-600 transition-colors" data-id="element-16340">
                      {t(item.labelKey)}
                    </div>
                    <div className="text-xs text-slate-500" data-id="element-16341">
                      {t(item.descKey)}
                    </div>
                  </div>
                </button>)}
            </div>
          </div>}
      </div>

      {/* 2. Астрологи */}
      <button onClick={() => handleNavClick('astrologers')} className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${currentPage === 'astrologers' ? 'text-indigo-600 bg-indigo-50' : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'}`} data-id="element-16342">
        {t('nav.astrologers')}
      </button>

      {/* 3. Маркетплейс */}
      <button onClick={() => handleNavClick('marketplace')} className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${currentPage === 'marketplace' ? 'text-indigo-600 bg-indigo-50' : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'}`} data-id="element-16343">
        Маркетплейс
      </button>

      {/* 4. Цены */}
      <button onClick={() => handleNavClick('pricing')} className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${currentPage === 'pricing' ? 'text-indigo-600 bg-indigo-50' : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'}`} data-id="element-16344">
        {t('nav.pricing')}
      </button>

      {/* 5. Знания Dropdown */}
      <div className="relative" ref={knowledgeRef} data-id="element-16345">
        <button onClick={() => {
        setIsKnowledgeOpen(!isKnowledgeOpen);
        setIsServicesOpen(false);
      }} className={`flex items-center gap-1 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${isKnowledgeActive ? 'text-indigo-600 bg-indigo-50' : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'}`} data-id="element-16346">
          Знания
          <ChevronDown className={`w-3.5 h-3.5 transition-transform duration-200 ${isKnowledgeOpen ? 'rotate-180' : ''}`} data-id="element-16347" />
        </button>
        {isKnowledgeOpen && <div className="absolute top-full right-0 mt-1.5 w-72 rounded-xl shadow-xl bg-white ring-1 ring-slate-900/5 z-50 overflow-hidden" data-id="element-16348">
            <div className="p-1.5" data-id="element-16349">
              {knowledgeItems.map(item => <button key={item.page} onClick={() => {
            handleNavClick(item.page);
            setIsKnowledgeOpen(false);
          }} className="flex items-start gap-3 w-full text-left px-3 py-2.5 rounded-lg hover:bg-slate-50 transition-colors group" data-id="element-16350">
                  <div className="mt-0.5 p-1.5 rounded-md bg-slate-50 group-hover:bg-white transition-colors" data-id="element-16351">
                    {item.icon}
                  </div>
                  <div data-id="element-16352">
                    <div className="text-sm font-semibold text-slate-900 group-hover:text-indigo-600 transition-colors" data-id="element-16353">
                      {item.labelKey.includes('.') ? t(item.labelKey) : item.labelKey}
                    </div>
                    <div className="text-xs text-slate-500" data-id="element-16354">{item.descKey}</div>
                  </div>
                </button>)}
            </div>
          </div>}
      </div>
    </nav>;
}